<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des fiches de stock</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row align-items-end"> <!-- align-items-end pour aligner les éléments en bas -->
          <!-- Bouton Ajouter une fiche -->
          <div class="col-md-4 d-flex align-items-end" v-if="checkPermission('AddFicheProduit')">
            <router-link class="btn btn-primary" to="/fiches/ajouter-fiche">
              <i class="fa fa-plus-circle"></i>
              Ajouter une fiche
            </router-link>
          </div>

          <!-- Champ Multiselect -->
          <div class="col-md-4" v-if="point_ventes.length > 1">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Filtrer par Point de vente
              </label>
              <div style="width: 200px;">
                <Multiselect v-model="point_vente" :options="point_ventes" :searchable="true" track-by="label"
                  label="label" placeholder="Sélectionner un point de vente" />
              </div>
            </div>
          </div>

          <!-- Champ de recherche avec bouton -->
          <div class="col-md-4">
            <div class="d-flex align-items-center">
              <form class="search-bg svg-color pt-3 w-100" @submit.prevent="rechercher">
                <div class="d-flex align-items-center">
                  <input type="text" v-model="searchTerm" @keyup="rechercher"
                    class="form-control shadow-none text-black flex-grow-1" placeholder="Rechercher une fiche" />
                  <button type="submit" class="bg-transparent text-primary transition p-0 border-0 ms-2">
                    <i class="flaticon-search-interface-symbol"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Numéro Fiche
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Produit
              </th>
              <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Unité de suivie
              </th> -->
              <!--<th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Stock Init.
              </th>-->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Stock
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Magasin
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ficheStock, index) in ficheStocks" :key="index">
              <td class="shadow-none lh-1 fw-medium ">{{ format_Date(ficheStock.dateCreation) }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.numFiche }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.produit?.nomProd }} | {{ ficheStock.produit?.refProd
                }} </td>
              <!-- <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.conditionnement?.libelle }} </td> -->
              <!-- <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.stockInit }} </td>-->
              <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.stock }} {{ ficheStock.conditionnement?.libelle }} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ ficheStock.magasin?.nomMagasin }} | {{
                ficheStock.magasin?.code}} </td>
              <td class="shadow-none lh-1 fw-medium ">{{ ficheStock?.statut }} </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu">
                    <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('DeleteFicheProduit')">
                      <a href="javascript:void(0);" @click="suppression(ficheStock.id, ficheStocks, 'ficheStocks', '')">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import ApiService from "@/services/ApiService";
import { FicheStock } from "@/models/FicheStock";
import { format_date, suppression, error, format_Date, separateur } from "@/utils/utils";

import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect'

export default defineComponent({
  name: "ListeFicheStock",
  components: {
    Multiselect,
    PaginationComponent
  },
  setup() {

    let point_vente = ref<string>("");
    let point_ventes = ref([]);
    onMounted(async () => {
      if (JwtService.getPointDeVente()) {
        point_vente.value = await JwtService.getPointDeVenteId();
      }
      const pointVentes = await JwtService.getPointDeVentes();
      point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
        value: point.id,
        label: point.nomPointVente
      })) : [];
      getAllFicheStocks(point_vente.value);
    });

    const ficheStocks = ref<Array<FicheStock>>([]);
    const ficheStock = ref<FicheStock>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllFicheStocks(point_vente.value,page_, limit_);
      } catch (error) {
        //
      }
    };

    watch(point_vente, () => {
      rechercher();
    });


    function rechercher() {
      getAllFicheStocks(point_vente.value, page.value, limit.value, searchTerm.value);
    }

    const recharger = () => {
      getAllFicheStocks(point_vente.value);
    };


    // END PAGINATE

    function getAllFicheStocks(point_vent, page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/ficheproduit?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          console.log(data.data.data, "zzzzzzzzzzzzzzzzzzzzzzz");
          ficheStocks.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return {
      ficheStocks,
      format_Date,
      checkPermission,
      format_date,
      suppression,
      ficheStock,
      page,
      totalPages,
      separateur,
      limit,
      totalElements,
      handlePaginate,
      searchTerm,
      rechercher,
      point_ventes,
      point_vente
    };
  },
});
</script>